import { render, staticRenderFns } from "./CancelInviteAdminUserPopup.vue?vue&type=template&id=60c81bb9"
import script from "./CancelInviteAdminUserPopup.vue?vue&type=script&lang=js"
export * from "./CancelInviteAdminUserPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../admin/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports